/**
 * userPrefs — Persistencia simple de preferencias de usuario en localStorage.
 *
 * Se usa un prefijo `cd:prefs:` para evitar colisiones. Cada preferencia es
 * independiente para que la lectura y escritura sea cheap y no dispare
 * re-renders innecesarios.
 *
 * Preferencias actuales:
 *   - chat_sound (bool): reproducir ding al conectar un contacto.
 */

const KEY_PREFIX = "cd:prefs:";

export function getPref(key, fallback) {
  try {
    const raw = window.localStorage.getItem(KEY_PREFIX + key);
    if (raw == null) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function setPref(key, value) {
  try {
    window.localStorage.setItem(KEY_PREFIX + key, JSON.stringify(value));
    // Notifica a listeners vía CustomEvent — Layout escucha esto para
    // actualizar su decisión de reproducir sonido sin re-renderizar en loop.
    window.dispatchEvent(
      new CustomEvent("cd:prefs:change", { detail: { key, value } })
    );
  } catch {
    /* ignore */
  }
}

export const PREF_KEYS = {
  CHAT_SOUND: "chat_sound",
};
